<div id="remedialProgress">
    <div class="row justify-between card-header px-6 py-3">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">
            Remedial Progress
        </div>
        <button (click)="openDialog('Remedial Progress','remedialProgress','createGroupBarChart')">
            <ng-container [ngTemplateOutlet]="expandIcon"></ng-container>
        </button>
    </div>

    <div class="px-6 pb-6 pt-2">
        <div style="height:45vh;" id="gorupedBarChart"></div>
    </div>
</div>